var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selected_tag"},[_c('span',{staticClass:"remove",on:{"click":function($event){return _vm.removeTag(_vm.tag)}}},[_vm._v("×")]),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.display_tag_name))])])}
var staticRenderFns = []

export { render, staticRenderFns }